import { cancel, Format, requestPermissions, scan, Scanned } from '@tauri-apps/plugin-barcode-scanner';
import { create } from 'zustand';

import { allowedPrefixes } from '@ui/Utils/scan/tag/allowedUrls';

interface CameraState {
    cameraOpen: boolean;
    cancel: () => void;
    errorMessage: string | null;
    isRenkiTag: boolean | null;
    redirectUrl: string | null;
    reset: () => void;
    scan: () => Promise<Scanned>;
    scannedContent: string | null;
}

function evaluateContent(content: string | null) {
    if (!content) {
        return {
            errorMessage: null,
            isRenkiTag: null,
            redirectUrl: null,
        };
    }
    const prefix = allowedPrefixes.find((p) => content.startsWith(p));
    if (prefix) {
        return {
            errorMessage: null,
            isRenkiTag: true,
            redirectUrl: content,
        };
    }
    return {
        errorMessage: 'This tag is not supported',
        isRenkiTag: false,
        redirectUrl: null,
    };
}

export const useCameraStore = create<CameraState>((set) => ({
    cameraOpen: false,
    cancel: () => {
        set({ cameraOpen: false });
        cancel().catch(console.error);
    },
    errorMessage: null,
    isRenkiTag: null,
    redirectUrl: null,
    reset: () => {
        set({ errorMessage: null, isRenkiTag: null, redirectUrl: null, scannedContent: null });
    },
    scan: async () => {
        await requestPermissions();
        set({
            cameraOpen: true,
            errorMessage: null,
            isRenkiTag: null,
            redirectUrl: null,
            scannedContent: null,
        });
        const value = await scan({ formats: [Format.QRCode], windowed: true });
        const content = value.content;
        const evaluation = evaluateContent(content);
        set({
            scannedContent: content,
            ...evaluation,
        });
        return value;
    },
    scannedContent: null,
}));
